import { render, staticRenderFns } from "./inventoryDetailBox.vue?vue&type=template&id=d94781d2&"
import script from "./inventoryDetailBox.vue?vue&type=script&lang=ts&"
export * from "./inventoryDetailBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports